(() => {
  if (customElements.get('leivip-videos-page')) return;
  class LeivipVideosPage extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        const modal = this.querySelector('.video-modal');
        if (!modal) return;
        const stage = modal.querySelector('.video-stage');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const restore = () => {
          stage.replaceChildren();
          if (!this.saved) return;
          const saved = this.saved;
          this.saved = null;
          document.body.style.cssText = saved.body;
          window.scrollTo(0, saved.y);
          if (saved.trigger.isConnected) saved.trigger.focus({ preventScroll: true });
          document.documentElement.style.scrollBehavior = saved.scroll;
        };
        this.restore = restore;
        this.modal = modal;
        this.addEventListener('click', event => {
          const button = event.target.closest('.video-trigger');
          if (!button || !this.contains(button) || modal.open) return;
          const id = button.dataset.video;
          if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
          this.saved = { trigger: button, y: window.scrollY, body: document.body.style.cssText, scroll: document.documentElement.style.scrollBehavior };
          document.documentElement.style.scrollBehavior = 'auto';
          document.body.style.position = 'fixed';
          document.body.style.top = `-${this.saved.y}px`;
          document.body.style.width = '100%';
          const frame = document.createElement('iframe');
          frame.title = button.dataset.title;
          frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          frame.allowFullscreen = true;
          frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&playsinline=1&rel=0`;
          stage.replaceChildren(frame);
          modal.showModal();
          modal.querySelector('.video-close').focus();
        }, options);
        modal.querySelector('.video-close').addEventListener('click', () => modal.close(), options);
        modal.addEventListener('close', restore, options);
        modal.addEventListener('click', event => {
          if (event.target !== modal) return;
          const r = modal.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) modal.close();
        }, options);
      });
    }
    disconnectedCallback() {
      if (this.modal?.open) this.modal.close();
      this.restore?.();
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('leivip-videos-page', LeivipVideosPage);
})();


(() => {
  const start = () => {
    const page = document.querySelector('leivip-videos-page');
    const cards = [...(page?.querySelectorAll('a.real-product') || [])];
    if (!cards.length && !page?.querySelector('.lv-native-video-product')) return;
    const style = document.createElement('style');
    style.textContent = `
      .lv-videos .real-product-copy .meta { display: none; }
      .lv-videos .real-products > .lv-native-video-product,
      .lv-videos .short-product-grid > .lv-native-video-product { width:100%; min-width:0; margin:0; padding:0; align-self:start; }
      .lv-videos .lv-native-video-product .block-inner { margin:0; }
      .lv-videos .lv-native-video-product .image-cont { max-width:none; }
      .lv-videos .lv-native-video-product .product-info { padding:14px 0 0; text-align:left; }
      .lv-videos .lv-native-video-product .product-block__title { line-height:1.5; }
      .lv-videos .lv-native-video-product .vendor { text-transform:uppercase; margin-bottom:8px; }
      .lv-videos .lv-native-video-product .product-price { margin-top:5px; }
      .lv-videos .lv-native-video-product .theme-money { visibility:visible; }
      .lv-videos .lv-native-video-product .product-block-options__item:nth-child(n+5) { display:none; }
      .lv-videos .lv-native-video-product .product-block-options { margin-top:12px; }
      .lv-videos .real-product.lv-native-fallback img { aspect-ratio:2/3; height:auto; }
      .lv-videos .real-product.lv-native-fallback .real-product-copy { padding:14px 0 0; }
      .lv-videos .real-product.lv-native-fallback .vendor { margin-bottom:8px; text-transform:uppercase; }
    `;
    page.prepend(style);
    const pendingStyle = document.createElement('style');
    pendingStyle.textContent = '.lv-videos a.real-product.lv-native-pending { visibility:hidden; }';
    page.prepend(pendingStyle);
    const cached = new Map();
    let searchSectionId;
    const root = window.Shopify?.routes?.root || '/';
    const queue = [];
    let running = 0;
    let wishlistReady;
    const loadWishlist = () => {
      if (wishlistReady) return wishlistReady;
      wishlistReady = (async () => {
        if (window.Flits?.wishlistButton?.settings) return;
        const brandLink = page.querySelector('.brand-view-all a[href*="/collections/"],a[href*="/collections/"]');
        if (!brandLink) return;
        const source = new URL(brandLink.href, location.origin);
        if (source.origin !== location.origin) return;
        const response = await fetch(source.href, {credentials:'same-origin'});
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const config = [...doc.querySelectorAll('script:not([src]):not([data-src])')].find(node => node.textContent.includes('window.flitsObjects.global =') && node.textContent.includes('window.flitsObjects.allCssJs ='));
        if (!config) return;
        if (!window.flitsObjects) {
          const bootstrap = document.createElement('script');
          bootstrap.textContent = config.textContent;
          page.append(bootstrap);
        }
        const sources = [...doc.querySelectorAll('script[src],script[data-src]')].map(node => node.getAttribute('src') || node.dataset.src).filter(src => /\/assets\/flits(?:_custom)?\.js(?:\?|$)/.test(src));
        for (const src of sources) {
          const url = new URL(src, location.origin);
          if (url.origin !== location.origin) continue;
          await new Promise(resolve => {
            const script = document.createElement('script');
            script.src = url.href; script.onload = resolve; script.onerror = resolve;
            page.append(script);
          });
        }
      })().catch(() => {});
      return wishlistReady;
    };
    const revealWishlist = product => {
      const flits = window.Flits;
      if (!flits?.wishlistButton?.settings || Number(flits.Metafields?.IS_WISHLIST_ENABLE) !== 1) return;
      const control = product.querySelector('.flits-wishlist-colection');
      if (!control) return;
      control.style.display = 'block';
      control.parentElement.setAttribute('data-flits','wishlist-collection-parent');
      const button = control.querySelector('.flits-wls-button');
      if (button && flits.isProductAddedInWishlist?.(button.dataset.flitsProductHandle) && !button.classList.contains('flits-wls-active')) {
        flits(button).animateWishlistButton(-1, button.getAttribute('data-tippy-content'));
      }
    };
    document.addEventListener('Flits:wishlistButton:Loaded', () => page.querySelectorAll('.lv-native-video-product').forEach(revealWishlist));
    loadWishlist();
    page.querySelectorAll('.lv-native-video-product').forEach(revealWishlist);
    const prepareProduct = product => {
    product.classList.add('lv-native-video-product');
    product.removeAttribute('data-cc-animate');
    product.querySelectorAll('script,style,noscript,.quickbuy-container,.quickbuy-toggle.btn').forEach(node => node.remove());
    const serverCustomer = product.querySelector('[data-flits-customer-id]')?.getAttribute('data-flits-customer-id');
    const signedIn = Boolean(window.cffCustomer?.id || (serverCustomer && serverCustomer !== '-1'));
    if (!signedIn) product.querySelectorAll('.product-price').forEach(node => node.remove());
    product.querySelectorAll('a[href]').forEach(link => {
      const target = new URL(link.getAttribute('href'), window.location.origin);
      if (target.origin === window.location.origin && target.pathname.includes('/products/')) {
        target.searchParams.delete('_pos'); target.searchParams.delete('_sid'); target.searchParams.delete('_ss');
        link.href = target.pathname + target.search + target.hash;
      }
    });
    product.querySelectorAll('img[data-src]').forEach(image => {
      image.src = image.dataset.src;
      image.loading = 'lazy';
      image.classList.remove('lazyload');
    });
    product.querySelectorAll('.lazyload--placeholder').forEach(node => node.classList.remove('lazyload--placeholder'));
    product.querySelectorAll('.image-cont').forEach(node => node.classList.remove('image-cont--with-secondary-image'));
    product.querySelectorAll('.image-page-button,.product-block__image-dots').forEach(node => node.remove());
    product.querySelectorAll('.product-block__image--primary').forEach(node => { node.className='product-block__image product-block__image--primary product-block__image--active'; });
    product.querySelectorAll('.product-block__image--secondary').forEach(node => { node.style.display='none'; });
    const vendor = product.querySelector('.vendor');
    if (vendor && /^(NEMIRA|NEMILA)$/i.test(vendor.textContent.trim())) vendor.textContent = 'NOEMI';
    const text = product.querySelector('.product-block__title');
    if (text) text.textContent = text.textContent.replace(/\s+wholesale$/i, '');
    product.querySelectorAll('.product-block-options__item').forEach(option => {
      const media = product.querySelector('[data-media-id="' + option.dataset.media + '"]');
      const primary = product.querySelector('.product-block__image--primary img');
      const image = media?.querySelector('img');
      const background = media?.querySelector('[data-lazy-bgset-src]');
      const src = image?.dataset.src || image?.getAttribute('src') || background?.dataset.lazyBgsetSrc;
      option.setAttribute('role','button'); option.tabIndex = 0;
      option.setAttribute('aria-label', option.dataset.optionItem || '');
      const select = () => {
        if (primary && src) primary.src = src;
        product.querySelectorAll('.product-block-options__item').forEach(item => item.setAttribute('aria-pressed', String(item === option)));
      };
      option.addEventListener('click', select);
      option.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); select(); } });
    });
    };
    page.querySelectorAll('.lv-native-video-product').forEach(prepareProduct);
    const load = async card => {
      if (card.dataset.lvNativeLoading) return;
      card.dataset.lvNativeLoading = 'true';
      try {
        const link = new URL(card.href, location.origin);
        if (link.origin !== location.origin) throw new Error('Invalid product origin');
        const handle = link.pathname.match(/\/products\/([^/]+)\/?$/)?.[1];
        if (!handle) throw new Error('Invalid product link');
        const productUrl = new URL(root + 'products/' + handle + '.js', location.origin);
        let data;
        for (let attempt = 0; attempt < 2; attempt += 1) {
          const response = await fetch(productUrl.href, {credentials:'same-origin'});
          if (response.status === 404 || response.status === 410) {
            const brand = card.closest('.brand-shop');
            card.remove();
            if (brand && !brand.querySelector('a.real-product,.lv-native-video-product')) brand.remove();
            return;
          }
          if (response.ok) { data = await response.json(); break; }
        }
        if (!data || !Number.isFinite(data.price) || !data.title || !data.id) throw new Error('Product data unavailable');
        if (card.dataset.productId && card.dataset.productId !== String(data.id)) throw new Error('Product ID mismatch');
        card.dataset.productId = String(data.id);
        const url = new URL(root + 'search', window.location.origin);
        url.searchParams.set('type', 'product');
        url.searchParams.set('q', 'title:"' + data.title.replace(/["\\]/g, '') + '"');
        if (searchSectionId) url.searchParams.set('section_id', searchSectionId);
        if (!cached.has(url.href)) cached.set(url.href, fetch(url.href, { credentials:'same-origin' }).then(response => {
          if (!response.ok) throw new Error('Search unavailable');
          return response.text();
        }));
        const doc = new DOMParser().parseFromString(await cached.get(url.href), 'text/html');
        const product = [...doc.querySelectorAll('.product-block[data-product-id]')].find(node => node.dataset.productId === card.dataset.productId);
        if (!product || !card.isConnected || !product.querySelector('.product-price__amount')) throw new Error('Native product card unavailable');
        const section = product.closest('[id^="shopify-section-"]');
        if (section) searchSectionId = section.id.replace(/^shopify-section-/, '');
        prepareProduct(product);
        card.replaceWith(product);
        revealWishlist(product);
      } catch (_) {
        card.dataset.lvNativeLoading = 'unavailable';
        card.hidden = true;
      }
    };
    const drain = () => {
      while (queue.length && running < (searchSectionId ? 4 : 1)) {
        running += 1;
        load(queue.shift()).finally(() => { running -= 1; drain(); });
      }
    };
    const observer = typeof window.IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target); queue.push(entry.target);
      });
      drain();
    }, {rootMargin:'600px'}) : null;
    cards.forEach(card => {
      card.querySelectorAll('.real-product-copy p').forEach(node => node.remove());
      card.classList.add('lv-native-fallback');
      card.classList.add('lv-native-pending');
      const brand = card.closest('.brand-shop')?.querySelector('.collection-head h2')?.textContent.trim();
      const copy = card.querySelector('.real-product-copy');
      if (brand && copy) {
        const vendor = document.createElement('div'); vendor.className='vendor';
        vendor.textContent = /^(NEMIRA|NEMILA)$/i.test(brand) ? 'NOEMI' : brand;
        copy.prepend(vendor);
      }
      if (observer) observer.observe(card); else queue.push(card);
    });
    if (!observer) drain();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();

